import CanalCobroDelete from './CanalCobroDelete'
export {CanalCobroDelete}
export default CanalCobroDelete
